module.exports = __webpack_public_path__ + "static/media/gear-position.3a0d4a89.svg";